module.exports = VueMeta;